'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
require('./_index.scss.js');

var CLASSNAME = 'varta-layout-general';
var cnOuterWrapper = "".concat(CLASSNAME, "__outer-wrapper");
var cnInnerWrapper = "".concat(CLASSNAME, "__inner-wrapper");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function LayoutGeneral(_ref) {
  var className = _ref.className,
      children = _ref.children,
      header = _ref.header,
      footer = _ref.footer,
      onMouseMove = _ref.onMouseMove,
      onTouchStart = _ref.onTouchStart,
      onKeyPress = _ref.onKeyPress,
      onClick = _ref.onClick;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, className),
    onMouseMove: onMouseMove,
    onTouchStart: onTouchStart,
    onKeyPress: onKeyPress,
    onClick: onClick
  }, header, /*#__PURE__*/React__default.createElement("div", {
    className: cnOuterWrapper
  }, /*#__PURE__*/React__default.createElement("main", {
    className: cnInnerWrapper
  }, children), footer));
}
LayoutGeneral.propTypes = {
  /** Child nodes */
  children: PropTypes.node,

  /** Additional class name */
  className: PropTypes.string,
  footer: PropTypes.node,
  header: PropTypes.node,
  onClick: PropTypes.func,
  onKeyPress: PropTypes.func,
  onMouseMove: PropTypes.func,
  onTouchStart: PropTypes.func
};

module.exports = LayoutGeneral;
